import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import logosmall from "../../assets/logo_small.svg";
import ScrollProgress from "./ScrollProgress";
import "./Navbar.css";

gsap.registerPlugin(useGSAP);

const WORDMARK = [
  { text: "MEDAYOUB", weight: "light" },
  { text: "CHEBBI.", weight: "bold" },
];

// intro: undefined = plain logo; false = waiting (logo hidden);
// true = play the wordmark-to-logo intro.
function Navbar({ intro }) {
  const header = useRef();

  useGSAP(
    () => {
      if (intro === undefined) return;
      // opacity, not autoAlpha: the hidden logo must stay hoverable
      gsap.set(".header-logo", { opacity: 0, scale: 0.6 });
      gsap.set(".wordmark-char", { yPercent: 110 });
      if (!intro) return;

      // Letters shrink away right-to-left into the logo; hover reverses it
      const collapse = gsap
        .timeline({ paused: true })
        .set(".header-wordmark", { pointerEvents: "none" })
        .to(".wordmark-char", { scale: 0, autoAlpha: 0, duration: 0.35, stagger: { each: 0.03, from: "end" }, ease: "power2.in" })
        .to(".header-logo", { opacity: 1, scale: 0.65, duration: 0.6, ease: "back.out(1.6)" }, "-=0.25");

      gsap
        .timeline({ delay: 0.9 })
        .to(".wordmark-char", { yPercent: 0, duration: 0.6, stagger: 0.025, ease: "power3.out" })
        .add(() => collapse.play(), "+=1.2");

      const brand = header.current.querySelector(".header-brand");
      const expand = () => collapse.reverse();
      const shrink = () => collapse.play();
      brand.addEventListener("mouseenter", expand);
      brand.addEventListener("mouseleave", shrink);
      return () => {
        brand.removeEventListener("mouseenter", expand);
        brand.removeEventListener("mouseleave", shrink);
      };
    },
    { scope: header, dependencies: [intro] },
  );

  return (
    <nav className="navbar-container">
      <div className="header" ref={header}>
        <div className="logo-radial-overlay"></div>
        <div className="header-brand">
          <img src={logosmall} className="header-logo" alt={"byMe"} />
          {intro !== undefined && (
            <span className="header-wordmark" aria-hidden="true">
              {WORDMARK.map(({ text, weight }) => (
                <span key={text} className={`wordmark-${weight}`}>
                  {[...text].map((c, i) => (
                    <span key={i} className="wordmark-char">{c}</span>
                  ))}
                </span>
              ))}
            </span>
          )}
        </div>
      </div>
      <div className="scroll-progress-wrap">
        <ScrollProgress />
      </div>
    </nav>
  );
}

export default Navbar;
